/**
 * Extracts initials from user data for avatar display
 * @param firstName - User's first name
 * @param email - User's email (fallback if first name isn't available)
 * @returns A single character representing the user's initials
 */
export const getAvatarInitials = ({
  firstName,
  email,
}: {
  firstName?: string | null
  email?: string | null
}): string => {
  if (firstName?.trim()) {
    return firstName.trim().charAt(0).toUpperCase()
  }

  if (email?.trim()) {
    return email.trim().charAt(0).toUpperCase()
  }

  return '?'
}
